import { ConfirmRequest } from './../constants/actionType'

const initialState = {
    contactInfo: {
        fName: "",
        lName: "",
        fNameErr: "",
        lNameErr: "",
        isValidfName: false,
        isValidlName: false,
        errorMsg: "",
        // bNameEnc: "",
        eMailId: "",
        eMailErr: "",
        phoneNoErr: "",
        isValidMail: false,
        isValidTN: false,
        emailValidationResp:"",
        emailRegexValid:true,
        clickHereFlag:false,

        phoneNo: {
            ph1: '',
            formattedph1: ''
        },
        tnType: "Mobile",
        isSMSOptIn: false,
        digitalBilling: "N"
    },
    yesWithdraw:false,
    reSendRequest:false,
    nsiStatusResponse:null,
    nsiFailure:false,
    nsiIndicator:'',
    nsiInterestCheck:true,
    nsiEmail:"",
    nsiEmailErr:false,
    nsiIDStatus:"",
    nsiIDStatusErr:"",
    faqNsiNotificationContent: '',    
    nsiContactInfo: {
        nsiFirstName: "",
        nsiLastName: "",
        nsiFirstNameErr: "",
        nsiLastNameErr: "",
        isValidFirstName: false,
        isValidLastName: false,
        errorMsg: "",
        nsiIDPmCompName:"",
        nsiIDPmMgrName:"",
        nsiIDPmMgrEmail:"",
        nsiIDPmMgrEmailErr:"",
        nsiIDOwnerLLName:"",
        nsiIDOwnerLLEmail:"",
        nsiIDOwnerLLEmailErr:"",
        nsiIDOwnerLLPhone:"",
        nsiIDOwnerLLPhoneErr:"",
        submittedForm: false    
    },
}

function nsi(state = initialState, action) {
    switch (action.type) {    	
     case "YES_WITHDRAW":
        return Object.assign({}, state, {
            yesWithdraw: action.value
        })
    case "NSI_STATUS":
        return Object.assign({}, state, {
            nsiStatusResponse: action.value
        })
    case "NSI_FAILED":
        return Object.assign({}, state, {
            nsiFailure: action.value
        })
    case 'NSI_INDICATOR':
           return Object.assign({}, state, {
               nsiIndicator: action.value
            })
    case "RESEND_REQUEST":
        return Object.assign({}, state, {
            reSendRequest: action.value
        })
    case "NSI_INTEREST":
        return Object.assign({}, state, {
            nsiInterestCheck: !action.value
        })
    case "NSI_EMAILERROR":
        return Object.assign({}, state, {
            nsiEmailErr: action.value
        })
    case "NSI_EMAIL_INPUT":
        return Object.assign({}, state, {
            nsiEmail: action.value
        })
    case "NSIID_STATUSERROR":
        return Object.assign({}, state, {
            nsiIDStatusErr: action.value
        })
    case "NSIID_STATUSINPUT":
        return Object.assign({}, state, {
            nsiIDStatus: action.value
        })
    case "FAQ_NSINOTIFICATION_CONTENT":
        return Object.assign({}, state, {
            faqNsiNotificationContent: action.value
        })    
    case "NSI_ERRORMSG":
        return Object.assign({}, state.nsiContactInfo, {
            errorMsg: action.value
        })
    case "NSI_UPDATEINFO_INITIALSTATE":
        return Object.assign({}, state, {
            nsiContactInfo: initialState.nsiContactInfo
        })
    case "NSI_UPDATEINFO":
        let nsiInfo = Object.assign({}, state.nsiContactInfo, action.value)
        return Object.assign({}, state, {
            nsiContactInfo: nsiInfo
        })
    case ConfirmRequest.onNameValidation:
        let validateddetails = Object.assign({}, state.contactInfo, {
            isValidfName: action.value.isValidFirstName,
            isValidlName: action.value.isValidLastName,
            fNameErr: (!action.value.isValidFirstName) ? "Please check the name you entered and enter the legal name" : state.contactInfo.fNameErr,
            lNameErr: (!action.value.isValidLastName) ? "Please check the name you entered and enter the legal name" : state.contactInfo.lNameErr
        })
        return Object.assign({}, state, {
            contactInfo: validateddetails
        })
    case ConfirmRequest.onContactValidation:
            let validateddata = Object.assign({}, state.contactInfo, {
            isValidMail: (action.value.emailIdValidationResult !== undefined && action.value.emailIdValidationResult.validationResult === 'INVALID') ? false : true,
            eMailErr: (action.value.emailIdValidationResult !== undefined && action.value.emailIdValidationResult.validationResult === 'INVALID') ? "Please enter a valid email address" : state.contactInfo.eMailErr,
            isValidTN: (action.value.mobileNumberValidationResult !== undefined && action.value.mobileNumberValidationResult.validationResult === 'INVALID') ? false : true,
            phoneNoErr: (action.value.mobileNumberValidationResult !== undefined && action.value.mobileNumberValidationResult.validationResult === 'INVALID') ? "Please enter Valid Contact #" : state.contactInfo.phoneNoErr,
        })
            let isvalidateddata = false;
            if (state.contactInfo.isValidfName && state.contactInfo.isValidlName
                && validateddata.isValidMail && validateddata.isValidTN
                && state.contactInfo.errorMsg === "") {
                isvalidateddata = true;
            }
            else if (action.value.isvalidateddata !== undefined) {
                isvalidateddata = action.value.isvalidateddata
            }    
        return Object.assign({}, state, {
            contactInfo: validateddata,
            isContactInfoValidated: isvalidateddata
        })
    case ConfirmRequest.updateNameInfo:
            let details = Object.assign({}, state.contactInfo, {
            fName: (action.value.fName !== undefined && action.value.fName !== state.contactInfo.fName) ? action.value.fName : state.contactInfo.fName,
            lName: (action.value.lName !== undefined && action.value.lName !== state.contactInfo.lName) ? action.value.lName : state.contactInfo.lName,
            fNameErr: (action.value.fNameErr !== undefined && action.value.fNameErr !== state.contactInfo.fNameErr) ? action.value.fNameErr : state.contactInfo.fNameErr,
            lNameErr: (action.value.lNameErr !== undefined && action.value.lNameErr !== state.contactInfo.lNameErr) ? action.value.lNameErr : state.contactInfo.lNameErr,
            errorMsg: (action.value.errorMsg !== undefined && action.value.errorMsg !== state.contactInfo.errorMsg) ? action.value.errorMsg : state.contactInfo.errorMsg,
            isValidfName: (action.value.isValidfName !== undefined && action.value.isValidfName !== state.contactInfo.isValidfName) ? action.value.isValidfName : state.contactInfo.isValidfName,
            isValidlName: (action.value.isValidlName !== undefined && action.value.isValidlName !== state.contactInfo.isValidlName) ? action.value.isValidlName : state.contactInfo.isValidlName,
            bNameEnc: window.ProtectString !== undefined && window.ProtectString && window.ProtectString(state.contactInfo.fName + " " + state.contactInfo.lName)
        })
        return Object.assign({}, state, {
            contactInfo: details
        })
        case ConfirmRequest.updateNsiNameInfo:

            let nsiDetails = Object.assign({}, state.nsiContactInfo, {
            nsiFirstName: (action.value?.nsiFirstName !== undefined && action.value?.nsiFirstName !== state.nsiContactInfo.nsiFirstName) ? action.value?.nsiFirstName : state.nsiContactInfo.nsiFirstName,
            nsiLastName: (action.value.nsiLastName !== undefined && action.value.nsiLastName !== state.nsiContactInfo.nsiLastName) ? action.value.nsiLastName : state.nsiContactInfo.nsiLastName,
            nsiFirstNameErr: (action.value.nsiFirstNameErr !== undefined && action.value.nsiFirstNameErr !== state.nsiContactInfo.nsiFirstNameErr) ? action.value.nsiFirstNameErr : state.nsiContactInfo.nsiFirstNameErr,
            nsiLastNameErr: (action.value.nsiLastNameErr !== undefined && action.value.nsiLastNameErr !== state.nsiContactInfo.nsiLastNameErr) ? action.value.nsiLastNameErr : state.nsiContactInfo.lNameErr,
            errorMsg: (action.value.errorMsg !== undefined && action.value.errorMsg !== state.nsiContactInfo.errorMsg) ? action.value.errorMsg : state.nsiContactInfo.errorMsg,
            isValidFirstName: (action.value.isValidFirstName !== undefined && action.value.isValidFirstName !== state.nsiContactInfo.isValidFirstName) ? action.value.isValidFirstName : state.nsiContactInfo.isValidFirstName,
            isValidLastName: (action.value.isValidLastName !== undefined && action.value.isValidLastName !== state.nsiContactInfo.isValidLastName) ? action.value.isValidLastName : state.nsiContactInfo.isValidLastName,
            
        })
        return Object.assign({}, state, {
            nsiContactInfo: nsiDetails
        })
    case ConfirmRequest.updateContactInfo:
            let data = Object.assign({}, state.contactInfo, {
            eMailId: (action.value.eMailId !== undefined && action.value.eMailId !== state.contactInfo.eMailId) ? action.value.eMailId : state.contactInfo.eMailId,
            eMailErr: (action.value.eMailErr !== undefined && action.value.eMailErr !== state.contactInfo.eMailErr) ? action.value.eMailErr : state.contactInfo.eMailErr,
            isValidMail: (action.value.isValidMail !== undefined && action.value.isValidMail !== state.contactInfo.isValidMail) ? action.value.isValidMail : state.contactInfo.isValidMail,
            isValidTN: (action.value.isValidTN !== undefined && action.value.isValidTN !== state.contactInfo.isValidTN) ? action.value.isValidTN : state.contactInfo.isValidTN,
            phoneNoErr: (action.value.phoneNoErr !== undefined && action.value.phoneNoErr !== state.contactInfo.phoneNoErr) ? action.value.phoneNoErr : state.contactInfo.phoneNoErr,
            tnType: (action.value.tnType !== undefined && action.value.tnType !== state.contactInfo.tnType) ? action.value.tnType : state.contactInfo.tnType,
            isSMSOptIn: (action.value.isSMSOptIn !== undefined && action.value.isSMSOptIn !== state.contactInfo.isSMSOptIn) ? action.value.isSMSOptIn : state.contactInfo.isSMSOptIn
        })
        return Object.assign({}, state, {
            contactInfo: data,
            isContactInfoValidated: (action.value.isContactInfoValidated !== undefined) ? action.value.isContactInfoValidated : state.isContactInfoValidated
        })       
    case ConfirmRequest.emailValidation:
            let emailValObj = Object.assign({}, state.contactInfo, {
            emailValidationResp : action.value
        })
        return Object.assign({}, state, {
            contactInfo: emailValObj
        })
    case ConfirmRequest.emailRegex:
            let eRegexObj = Object.assign({}, state.contactInfo, {
            emailRegexValid : action.value
        })
        return Object.assign({}, state, {
            contactInfo: eRegexObj
        })
    case ConfirmRequest.updateClickStatus:
            let clickObj = Object.assign({}, state.contactInfo, {
            clickHereFlag : action.value
        })
        return Object.assign({}, state, {
            contactInfo: clickObj
        })
    case 'UPDATE_PH1':
            let ph1 = Object.assign({}, state.contactInfo.phoneNo, {
            ph1: action.value
        })
            let ph1data = Object.assign({}, state.contactInfo, {
            phoneNo: ph1
        })
        return Object.assign({}, state, {
            contactInfo: ph1data
        })
    case ConfirmRequest.updateFormattedphone:
            let formattedph1 = Object.assign({}, state.contactInfo.phoneNo, {
            formattedph1: action.value
        })
            let formattedph1data = Object.assign({}, state.contactInfo, {
            phoneNo: formattedph1
        })
        return Object.assign({}, state, {
            contactInfo: formattedph1data
        })
    case 'UPDATE_PHONE': 
            let ph = Object.assign({}, state.contactInfo.phoneNo, {
            ph1: action.value.ph1
        })
            let phdata = Object.assign({}, state.contactInfo, {
            phoneNo: ph
        })
        return Object.assign({}, state, {
            contactInfo: phdata
        })
      default:
        return state
    }

}

export default nsi